import { useQuery } from "react-query";
import { ReferentialApi } from "../../api";
import { useApiService } from "../useApiService";

export function useFunctionalDirectorRef() {
  const api = useApiService(ReferentialApi);
  const { data, isFetching, refetch } = useQuery(
    "ref-functional-director",
    async () => {
      return await api.functionalDirectors();
    },
    { staleTime: Infinity }
  );

  return {
    dir: data ?? [],
    dirLoading: isFetching,
    refetchDirRef: refetch,
  };
}
